var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusStop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "car_2_",
    "data-name": "car(2)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6359",
    "data-name": "Rectangle 6359",
    width: 40,
    height: 40.006,
    fill: "#353841"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6355",
    "data-name": "Rectangle 6355",
    fill: "#f1f5ff",
    stroke: "#353841",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34966",
    "data-name": "Group 34966",
    transform: "translate(17 16.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34960",
    "data-name": "Group 34960",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24453",
    "data-name": "Path 24453",
    d: "M15.469,0H37.188c.174.047.35.086.521.141A3.2,3.2,0,0,1,40,3.474q0,13.471,0,26.942a1.6,1.6,0,0,1-.1.609c-.491,1.161-1,2.315-1.506,3.468a1.287,1.287,0,0,1-1.287.834c-.138,0-.276.011-.469.02v3.308c.028,0,.092.012.156.012.82,0,1.64,0,2.46,0a.677.677,0,0,1,.744.64A.691.691,0,0,1,39.25,40c-.065,0-.13,0-.2,0Q20,40,.946,40.006A.971.971,0,0,1,0,39.532v-.391a.913.913,0,0,1,.94-.479c.566.023,1.134.006,1.722.006v-.522q0-5.642,0-11.284a2.019,2.019,0,0,1,1.53-2.129c.147-.038.3-.057.461-.087V13.308c-.126-.032-.238-.062-.351-.088A5.259,5.259,0,0,1,.114,9.083C.073,8.921.038,8.757,0,8.594V7.422c.027-.113.06-.224.079-.338A5.327,5.327,0,0,1,10.4,6.36,5.25,5.25,0,0,1,8.144,12.5a16.525,16.525,0,0,1-2.116.908V24.619a5.362,5.362,0,0,1,.837.26A2.04,2.04,0,0,1,8,26.893c-.009,3.75,0,7.5,0,11.249v.505h8.026V35.356a1.559,1.559,0,0,0-.249-.028,1.489,1.489,0,0,1-1.628-1.1c-.407-1.013-.875-2-1.29-3.011a2.446,2.446,0,0,1-.185-.9q-.015-13.338-.007-26.677a7.349,7.349,0,0,1,.032-.78A3.149,3.149,0,0,1,13.706.847,3.679,3.679,0,0,1,15.469,0M38.657,29.981c.005-.112.011-.177.011-.242q0-13.22,0-26.44a1.863,1.863,0,0,0-2-1.967H16.128a1.9,1.9,0,0,0-2.134,2.145q0,13.044,0,26.088v.414H22c0-.382,0-.744,0-1.105a2.027,2.027,0,0,1,2.206-2.214q2.109-.01,4.218,0a2.041,2.041,0,0,1,2.235,2.231c0,.359,0,.719,0,1.091ZM38.3,31.357H14.364c.334.773.665,1.506.966,2.25a.543.543,0,0,0,.6.4q10.408-.017,20.815-.008a.778.778,0,0,0,.233-.005c.086-.028.2-.073.235-.142.367-.815.72-1.635,1.092-2.489M9.326,7.992A4.032,4.032,0,0,0,5.314,4a4.048,4.048,0,0,0-3.982,4.03,4.044,4.044,0,0,0,4,3.972A4.02,4.02,0,0,0,9.326,7.992M21.308,38.65H31.336v-3.3H21.308Zm-14.649.007V27.582c0-.247,0-.495,0-.742-.008-.6-.227-.826-.82-.834-.3,0-.6,0-.9,0-.737,0-.945.211-.945.957q0,5.641,0,11.282c0,.136,0,.272,0,.413Zm22.669-8.676c0-.366,0-.713,0-1.061-.005-.714-.214-.922-.94-.924q-2.049,0-4.1,0a.962.962,0,0,0-.458.053c-.177.1-.422.269-.441.431a12.978,12.978,0,0,0-.021,1.5Zm3.344,5.366c0,.914-.018,1.807.009,2.7a.618.618,0,0,0,.644.612c.441.023.885.023,1.326,0a.655.655,0,0,0,.67-.709c.012-.351,0-.7,0-1.054,0-.514,0-1.029,0-1.551Zm-15.33,0c0,.914-.011,1.786,0,2.656a.642.642,0,0,0,.678.661c.428.019.859.017,1.287,0a.616.616,0,0,0,.665-.587c.031-.9.01-1.81.01-2.73Z",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24454",
    "data-name": "Path 24454",
    d: "M167.639,88.6h8.707a2.047,2.047,0,0,1,2.276,2.264q0,4.393,0,8.786a2.054,2.054,0,0,1-2.261,2.285q-8.747,0-17.493,0a2.047,2.047,0,0,1-2.256-2.25q0-4.432,0-8.864a2.034,2.034,0,0,1,2.241-2.221q4.393,0,8.786,0m.014,1.331H158.9c-.738,0-.958.217-.958.951q0,4.375,0,8.75c0,.744.215.966.945.966q8.731,0,17.461,0c.716,0,.937-.223.938-.933q0-4.395,0-8.789c0-.732-.219-.945-.963-.946h-8.672",
    transform: "translate(-141.286 -79.928)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24455",
    "data-name": "Path 24455",
    d: "M167.2,31.882c-2.89,0-5.779-.007-8.669,0a2.026,2.026,0,0,1-2.053-1.069,2.75,2.75,0,0,1,.1-2.726,1.992,1.992,0,0,1,1.848-.886q4.53.005,9.059,0c2.864,0,5.727,0,8.591,0a1.967,1.967,0,0,1,2.06,1.512c.265,1.34.031,2.383-.991,2.9a2.7,2.7,0,0,1-1.163.251c-2.929.02-5.857.011-8.786.011m.017-1.332h8.745c.322,0,.718-.006.795-.346a2.859,2.859,0,0,0,0-1.317c-.105-.395-.555-.349-.909-.349H158.593a1.429,1.429,0,0,0-.463.033c-.162.057-.414.164-.431.277a3.71,3.71,0,0,0-.038,1.32c.091.4.532.381.891.381q4.333,0,8.667,0",
    transform: "translate(-140.888 -24.543)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24456",
    "data-name": "Path 24456",
    d: "M162,241.311a2.666,2.666,0,0,1-2.695,2.615,2.7,2.7,0,0,1-2.627-2.7,2.661,2.661,0,1,1,5.321.082m-2.667-1.373a1.335,1.335,0,0,0-1.321,1.316,1.354,1.354,0,0,0,1.345,1.341,1.326,1.326,0,0,0,1.31-1.365,1.307,1.307,0,0,0-1.334-1.291",
    transform: "translate(-141.347 -215.26)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24457",
    "data-name": "Path 24457",
    d: "M327.133,241.243a2.661,2.661,0,1,1,5.321,0,2.661,2.661,0,0,1-5.321,0m2.647-1.333a1.308,1.308,0,0,0-1.315,1.311,1.326,1.326,0,0,0,1.329,1.345,1.352,1.352,0,0,0,1.326-1.321,1.334,1.334,0,0,0-1.341-1.335",
    transform: "translate(-295.123 -215.233)",
    fill: "#353841"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusStop);
export default __webpack_public_path__ + "static/media/busStop.73da3d197aaf670615e1e9233801e3f4.svg";
export { ForwardRef as ReactComponent };